import CustomFontLoader from '../lib/font-loader.js';

const init = () => {
    var $missingAuthors = $('.missing-author');
    if ($missingAuthors.length < 1) return;

    var fontLoader = new CustomFontLoader('ITC Avant Garde Gothic W05 Boo');
    fontLoader.load().then(function() {
        $missingAuthors.each(function(i, el) {
            var $el = $(el);
            var $svg = $el.find('.missing-author__svg');
            var $text = $el.find('text');
            var textW = parseInt($text.width(), 10);
            var svgW = parseInt($svg.width(), 10);
            if (textW > svgW) {
                $text.attr('textLength', '98%');
                $text.attr('lengthAdjst', 'spacingAndGlyphs');
            }
        });
    }).catch(function(err) {
        console.warn('Font ITC Avant Garde Gothic W05 Boo failed to load:', err);
        // Still run the layout adjustment even if font fails
        $missingAuthors.each(function(i, el) {
            var $el = $(el);
            var $svg = $el.find('.missing-author__svg');
            var $text = $el.find('text');
            var textW = parseInt($text.width(), 10);
            var svgW = parseInt($svg.width(), 10);
            if (textW > svgW) {
                $text.attr('textLength', '98%');
                $text.attr('lengthAdjst', 'spacingAndGlyphs');
            }
        });
    });

}

export default init;